const wrap = (fn, ...args) => {
  return (e) => {
    e.stopPropagation();

    return fn(...args);
  };
};

export default wrap;
